<template>
    <ErrorScreen :warning="warning" :has-rp-panel="rpOnly" has-user-panel>
        <h3>{{ title }}</h3>
        <p v-if="html" v-html="message" />
        <p v-else>
            {{ message }}
        </p>
        <NewButton
            v-if="showHomeButton"
            color="primary"
            @click.prevent="navigateToHome"
        >
            Go to homepage
        </NewButton>
        <NewButton
            v-if="allowRefresh"
            :icon="faSyncAlt"
            color="primary"
            @click.prevent="$emit('refresh')"
        >
            Refresh page
        </NewButton>
        <NewButton
            v-if="showSignOutButton"
            color="secondary"
            @click.prevent="$emit('sign-out')"
        >
            Sign out
        </NewButton>
    </ErrorScreen>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';

    import ErrorScreen from '@/components/error-screen/ErrorScreen.vue';
    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'refresh', 'sign-out' ],
        components: { ErrorScreen, NewButton },
    })
    export default class ErrorPage extends Vue {
        private faSyncAlt = faSyncAlt;

        @Prop({ type: Boolean, default: false })
        private allowRefresh!: boolean;

        @Prop({ type: Boolean, default: false })
        private warning!: boolean;

        @Prop({ type: Boolean, default: false })
        private html!: boolean;

        @Prop({ type: Boolean, default: false })
        private rpOnly!: boolean;

        @Prop({ type: Boolean, default: false })
        private showHomeButton!: boolean;

        @Prop({ type: Boolean, default: false })
        private showSignOutButton!: boolean;

        @Prop({ type: String })
        private title!: string;

        @Prop({ type: String })
        private message!: string;

        private navigateToHome() {
            window.location.href = '/';
        }
    }
</script>
